import * as types from './types';

const initialState = {
  loaded: false,
  loading: false,
  errors: [],
  currentUserProfile: null,
  educationHistories: [],
  workHistories: [{}],
  geography: {},
  profileQuestionAnswers: [],
  profileQuestionAnswersLoaded: false,
  profileQuestionAnswersLoading: false,
  resumeParsingStatus: null,
  loadingResumeParsingStatus: false,
  jobRecommendations: {
    list: null,
    loading: false,
    loaded: false,
    errors: null,
  },
  systemNotifications: undefined,
  hasApplications: null,
};

const currentUserProfileReducer = (state = initialState, { type, payload, errors }) => {
  switch (type) {
    case types.USER_PROFILE_LOAD_SUCCESS:
      return {
        ...state,
        currentUserProfile: payload,
        // loaded: true,
        // loading: false,
      };
    case types.GEOGRAPHY_LOAD_SUCCESS:
      return {
        ...state,
        geography: payload,
      };
    case types.EDUCATION_HISTORY_LOAD_SUCCESS:
      return {
        ...state,
        educationHistories: payload,
      };
    case types.WORK_HISTORY_LOAD_SUCCESS:
      return {
        ...state,
        workHistories: payload,
      };
    case types.CERTIFICATION_LOAD_SUCCESS:
      return {
        ...state,
        certifications: payload,
      };

    case types.PROFILE_QUESTION_ANSWER_LOAD_SUCCESS:
      return {
        ...state,
        profileQuestionAnswers: payload,
        profileQuestionAnswersLoaded: true,
      };

    case types.PROFILE_QUESTION_ANSWERS_LOAD_START:
      return {
        ...state,
        profileQuestionAnswersLoaded: false,
        profileQuestionAnswersLoading: true,
      };

    case types.PROFILE_QUESTION_ANSWERS_LOAD_SUCCESS:
      return {
        ...state,
        profileQuestionAnswers: payload,
        profileQuestionAnswersLoaded: true,
        profileQuestionAnswersLoading: false,
      };

    case types.PROFILE_QUESTION_ANSWERS_LOAD_FAILURE:
      return {
        ...state,
        profileQuestionAnswers: [],
        profileQuestionAnswersLoaded: false,
        profileQuestionAnswersLoading: false,
      };

    case types.LOAD_FULL_PROFILE_FINISHED:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case types.LOAD_FULL_PROFILE_FAILURE:
      return {
        loaded: true,
        loading: false,
      };
    case types.LOAD_FULL_PROFILE_START:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case types.LOAD_JOB_RECOMMENDATIONS_START:
      return {
        ...state,
        jobRecommendations: {
          ...state.jobRecommendations,
          loading: true,
          loaded: false,
          errors: null,
        },
      };
    case types.LOAD_JOB_RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        jobRecommendations: {
          ...state.jobRecommendations,
          loading: false,
          loaded: true,
          list: payload,
          errors: null,
        },
      };
    case types.LOAD_JOB_RECOMMENDATIONS_FAILURE:
      return {
        ...state,
        jobRecommendations: {
          ...state.jobRecommendations,
          loading: false,
          loaded: true,
          list: null,
          errors,
        },
      };
    case types.USER_PROFILE_NOTIFICATIONS_LOAD_SUCCESS:
      return {
        ...state,
        systemNotifications: payload,
      };
    case types.USER_PROFILE_NOTIFICATIONS_LOAD_FAILURE:
      return {
        ...state,
        systemNotifications: null,
      };
    case types.LOAD_HAS_APPLICATIONS_SUCCESS:
      return {
        ...state,
        hasApplications: payload,
      };
    case types.USER_PROFILE_PARSE_RESUME_STATUS_LOAD_START:
      return {
        ...state,
        loadingResumeParsingStatus: true,
      };
    case types.USER_PROFILE_PARSE_RESUME_STATUS_LOAD_SUCCESS:
      return {
        ...state,
        resumeParsingStatus: payload,
        loadingResumeParsingStatus: false,
      };
    case types.USER_PROFILE_PARSE_RESUME_STATUS_LOAD_FAILURE:
      return {
        ...state,
        loadingResumeParsingStatus: false,
      };

    default:
      return state;
  }
};

export default currentUserProfileReducer;
